import { CustomerTickets } from 'redux/Purchases/types'

export const isTicketInTransfer = (ticket: CustomerTickets): boolean =>
  ticket.status === 'IN_TRANSFER' && !ticket.detachedAt

export const getTicketsInTransfer = (
  tickets?: CustomerTickets[] | null
): CustomerTickets[] => (tickets ?? []).filter(isTicketInTransfer)
